import styled from 'styled-components';
import { Row } from '../../layout/Row';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Controls = styled(Row as any)`
  @media (max-width: 1480px) {
    flex-direction: column;
    gap: 10px;
    padding-bottom: 10px;
  }
`;

export const ControlsLeftSide = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 1480px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;

    & > div:first-child {
      width: 100%;

      & > * {
        width: 100%;
      }
    }

    & > div:nth-child(2) {
      display: none;
    }
  }
`;

export const ControlsRightSide = styled.div`
  @media (max-width: 1480px) {
    width: 100%;

    & > * {
      width: 100%;
    }
  }
`;
